import { style, styleVariants } from "@vanilla-extract/css";
import {
  buttonPrimary,
  buttonSecondary,
  buttonTertiary
} from "../button/Button.css";
import { primitiveTokens } from "../theme/ThemeTokens.css";

export const iconWrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
/** Wraps a `disabled` button so its tooltip still gets the hover. */
export const disabledTooltipAnchor = style({
  display: "inline-flex"
});

export const iconButtonBase = style({
  position: "relative",
  padding: primitiveTokens.sizing["4x"],
  cursor: "pointer",
  borderRadius: primitiveTokens.radii.sm,
  borderWidth: primitiveTokens.strokes.md,
  borderStyle: "solid",
  borderColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  selectors: {
    "&:focus-visible": {
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      borderColor: "transparent",
      outline: "none"
    },
    "&:disabled": {
      cursor: "default"
    },
    // A disabled control gets no pointer events (Firefox) or swallows them
    // (Safari); this hands them to the anchor.
    [`${disabledTooltipAnchor} > &`]: {
      pointerEvents: "none"
    }
  }
});

export const iconButtonSizes = styleVariants({
  lg: {
    height: primitiveTokens.sizing["12x"],
    width: primitiveTokens.sizing["12x"]
  },
  md: {
    height: primitiveTokens.sizing["10x"],
    width: primitiveTokens.sizing["10x"]
  },
  sm: {
    height: primitiveTokens.sizing["9x"],
    width: primitiveTokens.sizing["9x"]
  },
  xs: {
    height: primitiveTokens.sizing["7x"],
    width: primitiveTokens.sizing["7x"],
    padding: primitiveTokens.sizing["3.5x"]
  }
});

export const iconButtonVariants = styleVariants({
  primary: buttonPrimary,
  secondary: buttonSecondary,
  tertiary: buttonTertiary
});

export const iconHidden = style({
  visibility: "hidden"
});
